function getRoot() {
  if (typeof document === 'undefined') return null;
  return document.documentElement;
}

export function hasAnyActive(s) {
  if (!s) return false;
  return (
    s.contrast !== 'default' ||
    s.textSize !== 100 ||
    s.textSpacing === true ||
    s.dyslexiaFont === true ||
    s.pauseAnimations === true ||
    s.highlightFocus === true ||
    s.highlightHover === true ||
    s.cursorSize !== 1 ||
    s.saturation !== 'none' ||
    s.underlineLinks === true ||
    s.readingGuide === true ||
    s.fontWeight === true ||
    s.readingMask === true ||
    s.hideImages === true ||
    s.keyboardNavigation === true
  );
}

export function applySettingsToDom(settings) {
  const el = getRoot();
  if (!el) return;

  el.classList.toggle('a11y-on', hasAnyActive(settings));

  el.style.setProperty('--a11y-text-size', settings.textSize + '%');
  el.style.setProperty('--a11y-line-height', settings.textSpacing ? '1.8' : '');
  el.style.setProperty('--a11y-letter-spacing', settings.textSpacing ? '0.12em' : '');
  el.style.setProperty('--a11y-word-spacing', settings.textSpacing ? '0.16em' : '');
  el.style.setProperty('--a11y-cursor-scale', String(settings.cursorSize || 1));

  el.setAttribute('data-a11y-contrast', settings.contrast);
  el.setAttribute('data-a11y-saturation', settings.saturation);
  el.setAttribute('data-a11y-font', settings.dyslexiaFont ? 'dyslexic' : 'default');
  el.setAttribute('data-a11y-focus', settings.highlightFocus ? 'on' : 'off');
  el.setAttribute('data-a11y-hover', settings.highlightHover ? 'on' : 'off');
  el.setAttribute('data-a11y-underline-links', settings.underlineLinks ? 'on' : 'off');
  el.setAttribute('data-a11y-pause-anim', settings.pauseAnimations ? 'on' : 'off');
  el.setAttribute('data-a11y-reading-guide', settings.readingGuide ? 'on' : 'off');
  el.setAttribute('data-a11y-cursor', settings.cursorSize !== 1 ? String(settings.cursorSize) : '1');
  el.setAttribute('data-a11y-font-weight', settings.fontWeight ? 'on' : 'off');
  el.setAttribute('data-a11y-reading-mask', settings.readingMask ? 'on' : 'off');
  el.setAttribute('data-a11y-hide-images', settings.hideImages ? 'on' : 'off');
  el.setAttribute('data-a11y-keyboard-navigation', settings.keyboardNavigation ? 'on' : 'off');
}

export function clearDomAttributes() {
  const el = getRoot();
  if (!el) return;
  el.classList.remove('a11y-on');
  ['--a11y-text-size', '--a11y-line-height', '--a11y-letter-spacing', '--a11y-word-spacing', '--a11y-cursor-scale'].forEach((p) => el.style.removeProperty(p));
  ['contrast', 'saturation', 'font', 'focus', 'hover', 'underline-links', 'pause-anim', 'reading-guide', 'cursor', 'font-weight', 'reading-mask', 'hide-images', 'keyboard-navigation'].forEach((a) => el.removeAttribute('data-a11y-' + a));
}
